import C, {RequestTypes} from "../constants";
import fetch from 'isomorphic-fetch';

export const recordTestResults = (req) => dispatch => {
    if (req === undefined || !req) {
        dispatch(addError("Failed to record test. Invalid request"));
        return;
    }

    if (req.type !== RequestTypes.RECORD_USER_AGREE) { //this request is going async. no need to disturb the user
        dispatch({
            type: C.PROCESSING,
            payload: true
        });
    }

    const reqAsJson = JSON.stringify(req);

    fetch("https://68f4jwvwki.execute-api.eu-central-1.amazonaws.com/dev/muzdrakova-record-test-depresia", {
        method: 'POST',
        headers: {
            "x-api-key": C.X_API_KEY
        },
        body: reqAsJson
    }).then(response => {
        if (response.status >= 400) {
            dispatch({
                type: C.PROCESSING,
                payload: false
            });
            throw new Error("Bad response from server. Failed to handle the request!");
        }
        return response.json();
    }).then(r => {

        console.log(r);

        if (r.success !== true) {
            dispatch(addError(r.message));
        } else {
            dispatch({
                type: C.SET_RECORD_ID,
                payload: r.recId
            });

            if (req.type === RequestTypes.RECORD_QUESTIONS) {
                dispatch({
                    type: C.SET_SHOW_RESULTS,
                    payload: true
                })
            }

            if (req.type === RequestTypes.RECORD_SESSION) {
                dispatch({
                    type: C.REQUIRE_CONTACT,
                    payload: true
                })
            }
        }

        dispatch({
            type: C.PROCESSING,
            payload: false
        });

    }).catch(error => {

        if (req.type === RequestTypes.RECORD_USER_AGREE) { //We are processing this async and silently
            return;
        }

        dispatch(
            addError(error.message)
        );

        dispatch({
            type: C.PROCESSING,
            payload: false
        });

    }).finally(() => {
        if (req.type !== RequestTypes.RECORD_SESSION) {
            console.log('Skipping the session recording')
            return;
        }
        let formData = new FormData();
        formData.append("project_name", "muzdrakova.com/test-za-depresia");
        formData.append("admin_email", "nadya@muzdrakova.com");
        formData.append("mail_subject", "New test submitted at muzdrakova.com");
        formData.append("sender_name", req.type === RequestTypes.RECORD_SESSION ? req.session.username : "Test Depresia");
        formData.append("sender_email", req.type === RequestTypes.RECORD_SESSION ? req.session.email : "nadya@muzdrakova.com");
        formData.append("sender_phone", req.session.phone);
        formData.append("sender_subject", "New test depresia");
        formData.append("sender_message", req.session.message + "\nRAW" + reqAsJson);

        let requestOptions = {
            method: 'POST',
            body: formData,
            redirect: 'follow'
        };

        fetch("https://www.muzdrakova.com/php/process_mail.php", requestOptions)
            .then(response => response.text())
            .then(result => console.log(result))
            .catch(error => console.log('error', error));
    })
};

export const addError = (error) => {
    return {
        type: C.ADD_ERROR,
        payload: error
    }
};

export const clearError = (index) => {
    return {
        type: C.CLEAR_ERROR,
        payload: index
    }
};

export const clearAllErrors = () => {
    return {
        type: C.CLEAR_ALL_ERRORS
    }
};